export const krRegularFields = [
  {
    name: "name",
    label: "title",
  },
  {
    name: "ownerIds",
    label: "owner_cap",
  },
  {
    name: "targetOperator",
    label: "key_result_type",
  },
  {
    name: "format",
    label: "unit",
  },
  {
    name: "target",
    label: "target_number",
  },
  {
    name: "initialValue",
    label: "initial_number",
  },
  {
    name: "description",
    label: "description",
  },
];
